export default "__VITE_ASSET__SGFZ7O4___"